export const isCancellationPolicyApplicable = (
  purchasePrice: number,
  threshold: number,
): boolean => purchasePrice <= threshold;
